import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react"

import { CircularProgress, Divider } from "@mui/material"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { useAxiosWithAuth } from "../../common/api/hooks/useAxiosWithAuth"
import { URL } from "../../common/api/urls"
import useAuth from "../../common/hooks/useAuth"
import usePermissions from "../../common/hooks/usePermissions"
import useSyncUidataNotifyFlags from "../../common/hooks/useSyncUidataNotifyFlags"
import {
  BOOKMARK_CATEGORY_AUTOSAVE,
  CONSTANTS,
  DEFAULT_CANDLE_TIME_FRAME,
  DEMO_POPUP_STATUS,
  DEMO_POPUP_TYPES,
  INSTRUMENT_POLLING_TIME,
  MP_CHART_RELOAD_TIME,
  TEXT_MSGS,
  TIME_FRAME_VALUES,
  USER_RESOURCES_LIST,
  USER_ROLE_FIELDS,
} from "../../common/utility/constant"
import {
  breakDSTR,
  isChartOptionAccessAllowed,
  IV_RANGE_SIDEBAR_SYMBOLS,
  transformAndReverseMap,
  useQuery,
} from "../../common/utility/helperFunc"
import {
  CHART_TYPE,
  MAX_PROFILE_TO_LOAD,
  ROTATING_COT_VAL,
  VA_TYPE,
  VP_TYPE,
} from "../../common/utility/mp_chart_constants"
import { UserSettingsContext } from "../../setup/routes-manager/RequireAuth"
import LineChartFooter from "./components/LineChartFooter"

import LineChart from "./line_chart"
import OrderflowContainer from "./orderflow_container"
import StockChartHV from "./stock_chart_hv"
import ChartContainer from "./chart_container"
import BarChartContainer from "./BarChartContainer";
import LineChartSettings from "./components/lc_settings"
import AppErrorPopup from "../../components/AppErrorPopup";
import LineChartNew from "./line_chart_new"
import LineChartFooterNew from "./components/LineChartFooterNew"
import CandleSettings from "./components/candle_settings"
import LineChartSettingsNew from "./components/lc_settings_new"
import OfDemoPopup from "./components/orderflow_demo_popup"
import DemoConfirmationPopup from "./components/of_demo_confirm_popup"
import VolxSettingsModal from "./components/volx_settings_local_modal"

// const DEFAULT_PROFILE_WIDTH=120;
// const DEFAULT_PROFILE_WIDTH_WEEKLY=200;
// const DEFAULT_PROFILE_WIDTH_MONTHLY=200;
// const DEFAULT_PROFILE_WIDTH_YEARLY=400;
const DEFAULT_PROFILE_WIDTH = 60
const DEFAULT_PROFILE_WIDTH_WEEKLY = 100
const DEFAULT_PROFILE_WIDTH_MONTHLY = 120
const DEFAULT_PROFILE_WIDTH_YEARLY = 400
const PROFILE_LOAD_FACTOR = 1.2

const LineChartContainerNew = (props) => {
  // console.log("props==========================>",props);
  // const [initialData,setInitialData]=useState(props?.tabData?.data?.[props.val] ?? undefined)
  const [tabData,setTabData]=useState(props?.tabData??undefined)
  const [initialData,setInitialData]=useState((props?.tabData?.data?.[props.val] &&props?.tabData?.data?.[props.val].type) ?props?.tabData?.data?.[props.val]: undefined)
 
  const [toggleState,setToggleState]=useState(true);
  const { auth, setAuth } = useAuth()
  const syncUidataNotifyFlags = useSyncUidataNotifyFlags()
  // ============================================================
  // NEW - Centralized Permission System
  // See: src/common/utility/permissionService.js
  // ============================================================
  const permissions = usePermissions();
  // OLD - Hardcoded PRO role and TBT_FEED resource check (DEPRECATED)
  // Replaced by: permissions.isEliteUser()
  // const isEliteUser=auth.resources.find(el=>el==USER_RESOURCES_LIST.TBT_FEED)
  // const isEliteUser = (auth.role.find(el => el == USER_ROLE_FIELDS.PRO) && auth.resources.find(el => el == USER_RESOURCES_LIST.TBT_FEED))
  // NEW - Use centralized permission service
  const isEliteUser = permissions.isEliteUser();

  const location = useLocation()
  // const [chartType, setChartType] = useState(
  //   props.chartType ? props.chartType : CHART_TYPE.LINE_CHART
  // )
  const [chartType, setChartType] = useState(initialData?.type ?? props.chartType ?? CHART_TYPE.LINE_CHART);
  const [previousChartType, setPreviousChartType] = useState(CHART_TYPE.LINE_CHART);
  const [previousStateData, setPreviousStateData] = useState(null);
  const { userSettings, setUserSettings } = useContext(UserSettingsContext)
  const from = "/login"
  const symbol = useQuery("symbol")
  // console.log("testing 1=", props.key, props.val,symbol,props.symbol)
  const [state, setState] = useState({
    isLoading: true,
    liveData: undefined,
    chartData: undefined,
    krlData: undefined,
    // instrument: props.symbol
    //   ? props.symbol
    //   : symbol && props.val == 0
    //   ? symbol
    //   : userSettings.data.default_instrument,
      instrument:props.symbol?props.symbol:(symbol&&props.val==0?symbol:userSettings.data.default_instrument_candle?userSettings.data.default_instrument_candle:userSettings.data.default_instrument),
      
    // instrument:symbol&&props.val==0?symbol:userSettings.data.default_instrument,
    isIncrementalData: false,
    lastLoadTime: -1,
    isInstrumentLive: false,
    // OLD - Hardcoded FAST_DATA role check (DEPRECATED)
    // Replaced by: permissions.getChartReloadInterval()
    // reloadInerval: auth.role.find((el) => el == USER_ROLE_FIELDS.FAST_DATA)
    //   ? MP_CHART_RELOAD_TIME.FAST_DATA
    //   : MP_CHART_RELOAD_TIME.SLOW_DATA,
    // NEW - Use centralized permission service
    reloadInerval: permissions.getChartReloadInterval(),
    pollingInterval: MP_CHART_RELOAD_TIME.POLLING_TIME,
    refreshInterval: -1,
    selectedTimeFrame: userSettings.data.default_tf_candle?userSettings.data.default_tf_candle:DEFAULT_CANDLE_TIME_FRAME,
    selectedTimeFrameFooter: userSettings.data.default_tf_candle?userSettings.data.default_tf_candle:DEFAULT_CANDLE_TIME_FRAME,
    isPollingAllowed: false,
    isTradingSessionActive: false,
    isJsonLoaded: false,
    isFirtLoadComplete: false,
    apiData: undefined,
    bookmarkData: undefined,
    isStatusCheckAllowed: false,
    statusCheckPollingInterval: MP_CHART_RELOAD_TIME.POLLING_TIME,
    isLivePollingAllowed: false,
    krlPollingTime: MP_CHART_RELOAD_TIME.KRL_POLLING_TIME,
    krlPollingAllowed: false,
    tradeDates: undefined,
    dstrData: undefined,
    chartRendered:false,
    selectedCot:userSettings.data.rotating_cot_candle?userSettings.data.rotating_cot_candle:ROTATING_COT_VAL["default"],
    selectedCot2:userSettings.data.rotating_cot_candle?userSettings.data.rotating_cot_candle:ROTATING_COT_VAL["default"]
  })
  const [
    cancelUiData,
    responseDataUiData,
    errorUiData,
    loadedUiData,
    resetUiData,
    executeAPIUiData,
  ] = useAxiosWithAuth()
  const [selectedInstrumentData, setSelectedInstrumentData] = React.useState()
  const [selectedInstrument, setSelectedInstrument] = React.useState("")
  const [instrumentsData, setInstrumentsData] = useState()
  const [instrumentsLoaded, setInstrumentsLoaded] = useState(false);
  const [plotType,setPlotType]=useState(props.stateData && props.stateData.data && props.stateData.data.plot?props.stateData.data.plot:"fut");
  const [plotData,setPlotData]=useState(props.stateData && props.stateData.data ?props.stateData.data:{plot:"fut",doix:false});
  const [toggleRefresh,setToggleRefresh]=useState(undefined)
  const [cancelPoll,responseDataPoll, errorPoll, loadedPoll, resetPoll,executeAPIPoll ] = useAxiosWithAuth();
  const [cancelSettingsApi,responseDataSettingsApi, errorSettingsApi, loadedSettingsApi, resetSettingsApi,executeAPISettingsApi ] = useAxiosWithAuth();

  const [instrumentsTimeStamp, setInstrumentsTimeStamp]=useState(undefined);

  const [footerLoaded, setFooterLoaded] = useState(false)
  // OLD - Hardcoded FAST_DATA role check (DEPRECATED)
  // Replaced by: permissions.isPremiumUser()
  // const [npocAllowed, setNPOCAllowed] = useState(
  //   auth.role.find((el) => el == USER_ROLE_FIELDS.FAST_DATA) ? true : false
  // )
  // NEW - Use centralized permission service
  const [npocAllowed, setNPOCAllowed] = useState(permissions.isPremiumUser())
  const [panel1Visible,setPanel1Visible]=useState(false);
  const [volxPanelModalVisible,setVolxPanelModalVisible]=useState(false);
  
  // Session-only BI toggle state (per-instrument)
  const [footerBiToggle, setFooterBiToggle] = useState({});
  
  // Core BI decision logic
  const shouldShowBI = (instrumentKey) => {
    // 1. Check session override for this instrument
    if (footerBiToggle[instrumentKey] !== null && footerBiToggle[instrumentKey] !== undefined) {
      return footerBiToggle[instrumentKey];
    }
    
    // 2. If global is explicitly OFF, everything is OFF
    if (userSettings.data.show_balance_imbalance_candle === false) {
      return false;
    }
    
    // 3. If global is ON (or undefined for new users), check instrument-specific setting
    const instrumentSettings = userSettings.data.candle_map?.[instrumentKey];
    if (instrumentSettings?.instrument_bi_enabled !== undefined) {
      return instrumentSettings.instrument_bi_enabled;
    }
    
    // 4. Default to true (for new users) or global setting
    return userSettings.data.show_balance_imbalance_candle !== undefined 
      ? userSettings.data.show_balance_imbalance_candle 
      : true;
  };
  
  // Get effective BI state for current instrument
  const getEffectiveBiState = () => {
    if (!selectedInstrumentData) {
      // For new users or when instrument data is not available, 
      // default to global setting (which defaults to true)
      return userSettings.data.show_balance_imbalance_candle !== undefined 
        ? userSettings.data.show_balance_imbalance_candle 
        : true;
    }
    return shouldShowBI(selectedInstrumentData.tpo_group);
  };
  
  // Initialize with effective state
  const [biToggleEnabled, setBiToggleEnabled] = useState(getEffectiveBiState());

  // Update biToggleEnabled when instrument or settings change
  useEffect(() => {
    const newEffectiveState = getEffectiveBiState();
    setBiToggleEnabled(newEffectiveState);
  }, [selectedInstrumentData, userSettings.data.show_balance_imbalance_candle, userSettings.data.candle_map]);

  const [msgState, setMsgState] = useState({
    open: false,
    msg: "",
    severity: "info",
  })

  const { open, msg, severity } = msgState

  const {
    isLoading,
    chartData,
    liveData,
    krlData,
    isIncrementalData,
    isInstrumentLive,
    lastLoadTime,
    reloadInerval,
    pollingInterval,
    instrument,
    refreshInterval,
    selectedTimeFrame,
    selectedTimeFrameFooter,
    isPollingAllowed,
    isTradingSessionActive,
    isJsonLoaded,
    isFirtLoadComplete,
    apiData,
    bookmarkData,
    isStatusCheckAllowed,
    statusCheckPollingInterval,
    isLivePollingAllowed,
    krlPollingTime,
    krlPollingAllowed,
    tradeDates,
    dstrData,
    chartRendered,
    selectedCot,
    selectedCot2
  } = state
  const stateRef = useRef(state)

  const [cancel, responseData, error, loaded, reset, executeAPI] =
    useAxiosWithAuth()
  const [
    cancelLive,
    responseDataLive,
    errorLive,
    loadedLive,
    resetLive,
    executeLive,
  ] = useAxiosWithAuth()
  const [
    cancelSaved,
    responseDataSaved,
    errorSaved,
    loadedSaved,
    resetSaved,
    executeAPISaved,
  ] = useAxiosWithAuth()
  const [
    cancelDelete,
    responseDataDelete,
    errorDelete,
    loadedDelete,
    resetDelete,
    executeAPIDelete,
  ] = useAxiosWithAuth()
  const [
    cancelStatus,
    responseDataStatus,
    errorStatus,
    loadedStatus,
    resetStatus,
    executeAPIStatus,
  ] = useAxiosWithAuth()
  const [
    cancelKRL,
    responseDataKRL,
    errorKRL,
    loadedKRL,
    resetKRL,
    executeAPIKRL,
  ] = useAxiosWithAuth()
  const [
    cancelKRLPoll,
    responseDataKRLPoll,
    errorKRLPoll,
    loadedKRLPoll,
    resetKRLPoll,
    executeAPIKRLPoll,
  ] = useAxiosWithAuth()

  const selectedInstrumentRef = useRef(selectedInstrument)
  const timeStampRef = useRef(instrumentsTimeStamp);
  const [selectedTPO, setSelectedTPO] = useState(2)
  const [selectedInstrumentTPOData, setSelectedInstrumentTPOData] = useState()
  const [globalVolumeVisible, setGlobalVolumeVisible] = useState(
    userSettings.data.show_global_vp
  )
  const [volumeNumberVisible, setVolumeNumberVisible] = useState(
    userSettings.data.show_global_vp_numbers
  )
  const [onlyVolumeProfile, setOnlyVolumeProfile] = useState(false)
  const [tpoOnVolume, setTpoOnVolume] = useState(false)
  const [perProfilelVolumeVisible, setPerProfileVolumeVisible] = useState(false)
  const [perProfileVolumeNumberVisible, setProfileVolumeNumberVisible] =
    useState(false)
  const navigate = useNavigate()
  const [autoCenter, setAutocenter] = useState(false)
  // const [viewState, setViewState] = React.useState({tpo_only:true,vol_tpo_side:false,only_vol:false,tpo_on_vol:false});
  const [viewState, setViewState] = React.useState({
    tpo_only:
      userSettings.data.vp_type == VP_TYPE.NONE ||
      userSettings.data.vp_type == VP_TYPE.BACKGROUND,
    vol_tpo_side: userSettings.data.vp_type == VP_TYPE.ASIDE,
    only_vol: userSettings.data.vp_type == VP_TYPE.ALONE,
    tpo_on_vol: userSettings.data.vp_type == VP_TYPE.BACKGROUND,
  })

  const [tpoBasedVA, setTPOBasedVA] = useState(userSettings.data.va_type)
  const [toggleReset, setToggleReset] = useState(false)
  const [toggleUnselect, setToggleUnselect] = useState(false)
  const [rightPanelConatinerState, setRightPanelConatinerState] = useState({
    show: false,
    metadata: undefined,
    histoticalData: undefined,
    selectedIndexes: [],
    isLiveSession: false,
  })
  const [toggleSave, setToggleSave] = useState(false)
  const [toggleSaveBookmark, setToggleBookmark] = useState(false)
  const [jsonData, setJsonData] = useState()
  const [vpType, setVPType] = React.useState(userSettings.data.vp_type)
  const [stateData, setStateData] = useState(props.stateData)
  const [openAutosaveDeleteDialog, setOpenAutosaveDeleteDialog] =
    useState(false)
  const [reloadInstrument, setReloadInstrument] = useState()
  const [isDirty, setIsDirty] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [toggleMPLoading, setToggleMPLoading] = useState(false)
  const [showTable, setShowTable] = useState(false)
  const [tableData, setTableData] = useState(false)
  const [levelData, setLevelData] = useState([-1, -1]);
  const [showSettings,setShowSettings]=useState(false);
  const [showDemoState,setShowDemoState]=useState({demoType:undefined});
  const [showDemoPopup,setShowDemoPopup]=useState(false);
  const [showDemoConfirmPopup,setShowDemoConfirmPopup]=useState(false);
  const [demoIndex,setDemoIndex]=useState(undefined);
  

  const openStockChart = () => {
    navigate(
      `/stock-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`,
      { replace: false }
    )
  }

  useEffect(() => {
    // executeAPIKRL(URL.GET_KRL_LIST,"POST",{"symbol":"NIFTY"})
    console.log("ISSUEOF props LC container new=", props,stateData,chartType,initialData)
    if (props.setChartType) props.setChartType(chartType)
      const timeout = setTimeout(() => {
        // setTabData(undefined);
        // setInitialData(undefined);
        console.log("Reload props LC container setInitialData=undefined"); 
    }, 1000);
    return () => {
      // just to clear the timeout when component unmounts
      clearTimeout(timeout)
    }
  }, [])

  const openMPChart = () => {
    setShowTable(false)
    if (chartType != CHART_TYPE.MARKET_PROFILE) {
      console.log("live panel resetRightPanel===1")
      props.resetRightPanel()
      // console.log("state=",state);
      setPollingAllowedVal(true)
      setChartType(CHART_TYPE.MARKET_PROFILE)
      if (props.setChartType != undefined)
        props.setChartType(CHART_TYPE.MARKET_PROFILE)

      if(props.setIsDirty){
        props.setIsDirty(true);
      }

      // setState((prevState) => ({
      //   ...prevState,
      //   isLoading:false}));

      // setSelectedInstrument(selectedInstrument);
    }
    // navigate(`/stock-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`, { replace: false });
  }

  const openLineChart = () => {
    // if (chartType != CHART_TYPE.LINE_CHART) {
      console.log("selected instrument", props.val, selectedInstrument)
      // const queryParams = new URLSearchParams(window.location.search);
      const paramValue = searchParams.get("symbol");
      console.log("live panel resetRightPanel===2 symbol=",symbol)
      if(paramValue) setSelectedInstrument(symbol);
      props.resetRightPanel()
      setPollingAllowedVal(false)
      setStateData(undefined);
      setToggleState(!toggleState);
      setChartType(CHART_TYPE.LINE_CHART)
      if (props.setChartType != undefined)
        props.setChartType(CHART_TYPE.LINE_CHART)
      if(props.setIsDirty){
        props.setIsDirty(true);
      }
    // }
    // navigate(`/line-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`, { replace: false });
  }

  const openOFChart = () => {
    setShowTable(false)
    if (chartType != CHART_TYPE.OF_CHART) {
      console.log("live panel resetRightPanel===1")
      props.resetRightPanel()
      // console.log("state=",state);
      setPollingAllowedVal(false)
      setChartType(CHART_TYPE.OF_CHART)
      if (props.setChartType != undefined)
        props.setChartType(CHART_TYPE.OF_CHART)
    }
      if(props.setIsDirty){
      props.setIsDirty(true);
    }
  }

  useEffect(() => {
    console.log(
      "Chart container Props changes, proUser",
      props.chartStateData,
      props.proUser
    )
  }, [props.chartStateData])

  



  

  

  //execute the data fetch on the component mount
  useEffect(() => {
 
    setIsDirty(true)
    setJsonData(undefined)
    setState((prevState) => ({
      ...prevState,
      isJsonLoaded: true,
      isFirtLoadComplete: true,
    }))
  }, [])

  useEffect(() => {
  
    if (selectedInstrument != undefined) {
    
      //save the current symbol in URL if its not in the bookmark view
      if (!searchParams.has("bookmarkID") && props.val == 0) {
        // setSearchParams({ symbol: selectedInstrument })
      }
      // setJsonData(undefined);
      setState((prevState) => ({
        ...prevState,
        // apiData:undefined,
        bookmarkData: undefined,
        // isJsonLoaded:false,
      }))
      setFooterLoaded(true)
     
    
      setIsDirty(true)
    }
  }, [selectedInstrument, selectedTimeFrame, toggleMPLoading])

  useState(() => {
    console.log("charttype,state", chartType, state)
  }, [state])
 




  

  /**
   * autoclosing of the snackbar msg bar
   */
  const handleClose = (event, reason) => {
    setMsgState({ ...msgState, open: false })
  }


  const setPollingAllowedVal = (val) => {
    setState((prevState) => ({
      ...prevState,
      isPollingAllowed: val,
    }))
  }

  

  

  const handleVPType = (val) => {
    setVPType(val)
  }

  const handleFooterLoaded = () => {
    setFooterLoaded(true)
  }

  const handleChartChange = (data) => {
    console.log("handleChartChange", data)
    if (!isChartOptionAccessAllowed(permissions, data)) {
      showSubscribeModal()
      return
    }
    if(props.setIsDirty){
      props.setIsDirty(true);
    }
    setPreviousChartType(chartType);
    setPreviousStateData(stateData);
    setStateData(data)
    setChartType(data.data.chart_type)
  }

  // Revert to previous chart when restricted chart load fails
  const revertToPreviousChart = () => {
    // console.log("Reverting to previous chart:", previousChartType)
    setStateData(previousStateData);
    setChartType(previousChartType);
    if (props.setChartType) {
      props.setChartType(previousChartType);
    }
  }

  
  useEffect(() => {
    selectedInstrumentRef.current = selectedInstrument
    console.log(
      "useeffect selectedinstrument",
      selectedInstrument,
      selectedInstrumentRef.current
    )
  }, [selectedInstrument])
  
  // Update biToggleEnabled when selectedInstrumentData or settings change
  useEffect(() => {
    if (selectedInstrumentData) {
      const effectiveState = getEffectiveBiState();
      console.log("DEBUG BI Toggle: Effective state for", selectedInstrumentData.tpo_group, ":", effectiveState);
      setBiToggleEnabled(effectiveState);
    }
  }, [selectedInstrumentData, userSettings.data, footerBiToggle])

  
  

 

  const showPriceTable = () => {
    console.log("showTable=", showTable)
    if(props.setIsDirty){
      props.setIsDirty(true);
    }
    setShowTable(true)
  }

  const showSubscribeModal = (isCustom, msg) => {
    props.openSubscribeModal(isCustom, msg)
  }

 

 
  useEffect(() => {
    console.log("Boundary levelData useeffect chart container=", levelData)
    // loadDataLevel();
  }, [levelData])

  const openSunscriptionModal = (isCustom, msg) => {
    props.openSubscribePropModal(isCustom, msg)
  }

  useEffect(() => {
    console.log("LCContainer symbol=",symbol,props.symbol,tabData,initialData,initialData?.data?.symbol);
    
    const filtered = [props.symbol, symbol, initialData?.data?.symbol].filter(
      (instrument) => instrument !== null && instrument !== undefined
    );
    const additionalInstruments = filtered.length > 0 ? filtered : undefined;
      console.log("LCContainer symbol=",additionalInstruments)
    let data = {
      symbol: "NIFTY",
      instruments: 1,
      tpoList: 1,
      additional_instruments: additionalInstruments,
      // additional_instruments: symbol?[symbol]:undefined,
      dateList: 1,
    }
    if (timeStampRef.current !== undefined) {
      data.instruments_ts = timeStampRef.current;
    }
    console.log("Straddle test data=",data)
    executeAPIUiData(URL.MPCHART_UIDATA, "POST", data)
  }, [])

    useEffect(() => {
      const timeout = setInterval(() => {

        let data = {
          symbol: "NIFTY",
        }
        if (timeStampRef.current !== undefined) {
            data.instruments_ts = timeStampRef.current;
          }

        try {
          executeAPIPoll(URL.MPCHART_UIDATA, "POST", data);
        } catch (error) {
          console.error("API Poll error:", error);
        }
      }, INSTRUMENT_POLLING_TIME);

      return () => {
        console.log("Cleanup called");
        clearInterval(timeout);
      };
    }, []);

  // Handle settings API response
  useEffect(() => {
    if (loadedSettingsApi) {
      if (responseDataSettingsApi != null) {
        console.log("DEBUG BI Toggle: Settings saved successfully", responseDataSettingsApi);
      } else if (errorSettingsApi !== null) {
        console.error("DEBUG BI Toggle: Error saving settings", errorSettingsApi);
      }
      resetSettingsApi();
    }
  }, [loadedSettingsApi, responseDataSettingsApi]);

  useEffect(() => {
      timeStampRef.current = instrumentsTimeStamp;
  }, [instrumentsTimeStamp]);

  useEffect(() => {
    if (loadedPoll) {
      if (responseDataPoll != null) {
        if (responseDataPoll.of_demo_status != undefined && responseDataPoll.notify_of_demo) {
          if (responseDataPoll.of_demo_status === DEMO_POPUP_STATUS.DEMO_NOT_STARTED) {
            setShowDemoState({ demoType: DEMO_POPUP_TYPES.NEW_USER });
            setShowDemoPopup(true);
          } else if (responseDataPoll.of_demo_status === DEMO_POPUP_STATUS.DEMO_STARTED) {
            setShowDemoState({ demoType: DEMO_POPUP_TYPES.DEMO_ACTIVE });
            setShowDemoPopup(true);
            setDemoIndex(responseDataPoll.demo_index);
          } else if (responseDataPoll.of_demo_status === DEMO_POPUP_STATUS.DEMO_FINISHED) {
            const hasOfferTr = responseDataPoll.of_demo_offer_tr !== undefined && responseDataPoll.of_demo_offer_tr !== null;
            setShowDemoState({ demoType: DEMO_POPUP_TYPES.DEMO_COMPLETED, hasOfferTr: hasOfferTr });
            setShowDemoPopup(true);
          }
        }
        if (responseDataPoll.instruments_ts){
          setInstrumentsTimeStamp(responseDataPoll.instruments_ts);
        }
        syncUidataNotifyFlags(responseDataPoll);
      } else if (error !== null) {
        console.log("Error data=", error)
        reset()
      }
    }
  }, [loadedPoll, responseDataPoll])

  /**
   * API response handler
   */
  useEffect(() => {
    if (loadedUiData) {
      if (responseDataUiData != null) {
        if (responseDataUiData.instruments) {
          responseDataUiData.instruments = responseDataUiData.instruments.map((item) =>
          transformAndReverseMap(item)
        );
        console.log("Straddle test uidata response=",symbol,props.symbol,location,responseDataUiData);
        responseDataUiData.instruments = responseDataUiData.instruments.filter(
          (e) => e.cc === true
        )
        const ivRangePlot =
          initialData?.data?.plot === "spt_ivr" ||
          props.stateData?.data?.plot === "spt_ivr";
        if (ivRangePlot) {
          const allowed = new Set(IV_RANGE_SIDEBAR_SYMBOLS);
          responseDataUiData.instruments =
            responseDataUiData.instruments.filter((e) =>
              allowed.has(e.instr),
            );
        }
        let index = 0;
        if (initialData?.data?.symbol) {
          index = responseDataUiData.instruments.findIndex(
            (item) => item.instr === initialData?.data?.symbol
          )
          // console.log("Testing444 props",symbol,props.symbol,location,index)
          if (index == -1) index = 0
        }
        else if (props.symbol != undefined && props.symbol != "") {
          index = responseDataUiData.instruments.findIndex(
            (item) => item.instr === props.symbol
          )
          // console.log("Testing444 props",symbol,props.symbol,location,index)
          if (index == -1) index = 0
        } else if (props.val==0 && symbol != undefined && symbol != "") {
          index = responseDataUiData.instruments.findIndex(
            (item) => item.instr === symbol
            // (item) => item.instr === props.symbol?props.symbol:symbol
          )
          // console.log("Testing444 query param",symbol,props.symbol,location,index,responseDataUiData.instruments)
          if (index == -1) index = 0
        } 
        else if (
          userSettings != undefined &&
          userSettings.data != undefined
        ) {
          index = responseDataUiData.instruments.findIndex(
            (item) => item.name === userSettings.data.default_instrument_candle
          )
          if (index == -1){
            index = responseDataUiData.instruments.findIndex(
              (item) => item.name === "NIFTY"
            )
          } 

           if (index == -1) index = 0
        }
        // setOptions(responseDataUiData.instruments)
        if(!responseDataUiData.instruments[index].of){
          console.log("StraddleTest LCContainer 1",responseDataUiData.instruments[index])
          setState((prevState) => ({
            ...prevState,
            selectedTimeFrame:"1",
            selectedTimeFrameFooter:"1"
          }))
        }
        setInstrumentsData(responseDataUiData.instruments) // all data
        if(props.stateData==undefined&& props.val==0 && !props.isGlobalBookmark){
          console.log("testing444 searchparams test line chart container=",props.stateData)
          setSearchParams({"symbol":responseDataUiData.instruments[index].instr})
        }
        // console.log("Testing444 index=",index)
        setSelectedInstrument(responseDataUiData.instruments[index].instr) // only name of selected data
        setSelectedInstrumentData(responseDataUiData.instruments[index]) // current selected all data
        setInstrumentsLoaded(true);
        if(props.addSymbol)
          props.addSymbol(responseDataUiData.instruments[index].instr)
        }
        
        if (responseDataUiData.of_demo_status != undefined && responseDataUiData.notify_of_demo) {
          if (responseDataUiData.of_demo_status === DEMO_POPUP_STATUS.DEMO_NOT_STARTED) {
            setShowDemoState({ demoType: DEMO_POPUP_TYPES.NEW_USER });
            setShowDemoPopup(true);
          } else if (responseDataUiData.of_demo_status === DEMO_POPUP_STATUS.DEMO_STARTED) {
            setShowDemoState({ demoType: DEMO_POPUP_TYPES.DEMO_ACTIVE });
            setShowDemoPopup(true);
            setDemoIndex(responseDataUiData.demo_index);
          } else if (responseDataUiData.of_demo_status === DEMO_POPUP_STATUS.DEMO_FINISHED) {
            const hasOfferTr = responseDataUiData.of_demo_offer_tr !== undefined && responseDataUiData.of_demo_offer_tr !== null;
            setShowDemoState({ demoType: DEMO_POPUP_TYPES.DEMO_COMPLETED, hasOfferTr: hasOfferTr });
            setShowDemoPopup(true);
          }
        }
        if (responseDataUiData.instruments_ts){
          setInstrumentsTimeStamp(responseDataUiData.instruments_ts);
        }
        syncUidataNotifyFlags(responseDataUiData);
      //   setState((prevState) => ({
      // ...prevState,
      // isLoading:false,
      // }));

        // setTradeDates(responseData.tradeDates);
        // props.instrumentChange(
        //   responseData.instruments[index],
        //   responseData.tpo_groups[responseData.instruments[index].tpo_group]
        //     ? responseData.tpo_groups[responseData.instruments[index].tpo_group]
        //     : responseData.tpo_groups["DEFAULT"],
        //   tempTPO,
        //   responseData.tradeDates
        // );
        // setInstrumentLoaded(true);
      } else if (errorUiData !== null) {
        console.log("Error data=", error)
        resetUiData()
      }
    }
  }, [loadedUiData, responseDataUiData])

  const instrumentChange = (data) => {
    console.log("Instrumentsdropdown =instrumentChange",props.val,data.instr)
    setSelectedInstrument(data.instr)
    setSelectedInstrumentData(data)
   
  }

  const setChartRenderedState=(val)=>{
    setState((prevState)=>({
      ...prevState,
      chartRendered:val
    }))

    if(props.setChartLoaded){
      // console.log("HelloTest val 1=",val)
      const timeout = setTimeout(() => {
        props.setChartLoaded(val);
    }, 1000);
  }
    
   }

   useEffect(() => {
    console.log("LCReload statedata line chart container useEffect is called for props.stateData Line chart container",props.stateData)
   
    // if(instrumentsData && props.stateData){
    //   setInstrumentsLoaded(false);
    //   let index = responseDataUiData.instruments.findIndex((item) => item.instr === props.stateData.symbol)
    //   console.log("useEffect is called for props.stateData Line chart container 1",props.stateData,index)
    //   if(index!=-1){
    //     setSelectedInstrument(responseDataUiData.instruments[index].instr) // only name of selected data
    //     setSelectedInstrumentData(responseDataUiData.instruments[index]) // current selected all data
    //     }
    // }
    if(props.stateData){
      setState((prevState) => ({
        ...prevState,
        selectedTimeFrame:"1",
        selectedTimeFrameFooter:"1",
        selectedCot:userSettings.data.rotating_cot_candle?userSettings.data.rotating_cot_candle:ROTATING_COT_VAL["default"],
        selectedCot2:userSettings.data.rotating_cot2_candle?userSettings.data.rotating_cot2_candle:ROTATING_COT_VAL["default"]
 
      }))
    }else{
      console.log("StraddleTest LCContainer 2",selectedInstrumentData)
      setState((prevState) => ({
        ...prevState,
        selectedTimeFrame:userSettings.data.default_tf_candle?userSettings.data.default_tf_candle:DEFAULT_CANDLE_TIME_FRAME,
        selectedTimeFrameFooter:userSettings.data.default_tf_candle?userSettings.data.default_tf_candle:DEFAULT_CANDLE_TIME_FRAME,
        selectedCot:userSettings.data.rotating_cot_candle?userSettings.data.rotating_cot_candle:ROTATING_COT_VAL["default"],
        selectedCot2:userSettings.data.rotating_cot2_candle?userSettings.data.rotating_cot2_candle:ROTATING_COT_VAL["default"]
 
      }))
    }
    setStateData(props.stateData);

    // setInstrumentsLoaded(true);

  }, [props.stateData])

  useEffect(() => {
    console.log("Watchlist toggle refresh lc containr", props.toggleRefresh, toggleRefresh, toggleState)
    //  if(toggleRefresh!=props.toggleRefresh)
    if (toggleRefresh != undefined) {
      setStateData();
      setToggleState(!toggleState)
    }
    setToggleRefresh(props.toggleRefresh)


  }, [props.toggleRefresh])

    const onRefreshInstruments = () => {
      const filtered = [props.symbol, symbol, initialData?.data?.symbol].filter(
        (instrument) => instrument !== null && instrument !== undefined
      );
      const additionalInstruments = filtered.length > 0 ? filtered : undefined;

      let data = {
        symbol: "NIFTY",
        instruments: 1,
        tpoList: 1,
        additional_instruments: additionalInstruments,
      }
      if (timeStampRef.current !== undefined) {
        data.instruments_ts = timeStampRef.current;
      }
      console.log("Straddle test data=",data)
      executeAPIUiData(URL.MPCHART_UIDATA, "POST", data)
    }



  const openSettings=()=>{
    setShowSettings(true);
   }
  
   const cancelSettings=()=>{
    setShowSettings(false);
   }
  
   const saveSettings=(settings)=>{
    console.log("MP Settings save settings in chart container",settings);
    setUserSettings(settings);
   }

   const changeInstrument=(data)=>{
    console.log("LCCOntainer changeInstrument",plotType)
    setSelectedInstrument(data.instr);
    setSelectedInstrumentData(data);
    console.log("StraddleTest LCContainer 3",data)
    setState((prevState) => ({
      ...prevState,
      selectedTimeFrame:data.of==false?"1":userSettings.data.default_tf_candle?userSettings.data.default_tf_candle:DEFAULT_CANDLE_TIME_FRAME,
      selectedTimeFrameFooter:data.of==false?"1":userSettings.data.default_tf_candle?userSettings.data.default_tf_candle:DEFAULT_CANDLE_TIME_FRAME,
      selectedCot:userSettings.data.rotating_cot_candle?userSettings.data.rotating_cot_candle:ROTATING_COT_VAL["default"],
      selectedCot2:userSettings.data.rotating_cot2_candle?userSettings.data.rotating_cot2_candle:ROTATING_COT_VAL["default"]
 
      // selectedTimeFrame:"1"
    }))
   
   
   }

   const changePlotType=(data)=>{
    console.log("TestCandle LCContainer changePlotType type=",data);
    setPlotType(data.plot);
    setPlotData(data);
   
   }

   const changeTimeFrame=(val,isInternal=false,data=undefined)=>{
    console.log("StraddleTest LCContainer 4",val,data,selectedTimeFrame,selectedTimeFrameFooter)
    console.log("Timeframe LCContainer tf val=",val,isInternal,selectedTimeFrame,selectedTimeFrameFooter);
    if(data){
      setSelectedInstrument(data.instr);
      setSelectedInstrumentData(data)
    }

    if(selectedTimeFrameFooter==val)
        return;

  
    const timeout = setTimeout(() => {
    setState((prevState) => ({
      ...prevState,
      selectedTimeFrame:val,
      selectedTimeFrameFooter:val
    }))
    
  }, 100);

    
      }

  const cotChanged=(value)=>{
    setState((prevState) => ({
      ...prevState,
      selectedCot:value
    })); 
   
  }    

  const changePanel1Visibility=(val,forced=false)=>{
    console.log("Panel1 test Outer changePanel1Visibility=",val,panel1Visible)
    if(val!=undefined){
    console.log("Panel1 test changePanel1Visibility=",val,panel1Visible)
    setPanel1Visible(val)
    }
    if(forced){
      setPanel1Visible(val);
    }
    
    // For Volx chart, toggle the modal
    if(plotType === "all_volx"){
      setVolxPanelModalVisible(val !== undefined ? val : !volxPanelModalVisible);
    }
  }

  // Apply Volx settings (session-only, updates userSettings temporarily)
  const applyVolxSettings = (data) => {
    console.log("Apply Volx settings (session-only):", data, plotType);
    
    // Use the same helper function that the chart component uses
    const getBottomPanelViewName = (plot) => {
      if(plot=="all_volx")
        return "panel1_view_all_volx";
      else if(plot=="all_doi")
        return "panel1_view_oi_change";
      else if(plot=="all_doix")
        return "panel1_view_ntm_oi_change";
      else if(plot=="all_vol")
        return "panel1_view_all_vol";
      else if(plot=="all_dvolx")
        return "panel1_view_all_dvolx";
      else return "unknown_bottom_view";
    };
    
    const getBottomPanelHeightName = (plot) => {
      if(plot=="all_volx")
        return "panel1_height_all_volx";
      else if(plot=="all_doi")
        return "panel1_height_oi_change";
      else if(plot=="all_doix")
        return "panel1_height_ntm_oi_change";
      else if(plot=="all_vol")
        return "panel1_height_all_vol";
      else if(plot=="all_dvolx")
        return "panel1_height_all_dvolx";
      else return "unknown_bottom_height";
    };
    
    const viewName = getBottomPanelViewName(plotType);
    const heightName = getBottomPanelHeightName(plotType);
    
    // Import helper functions for info panel and LVO settings
    const getInfoPanelViewName = (plot) => {
      if(plot=="all_volx")
        return "info_panel_view_all_volx";
      else if(plot=="all_doi")
        return "info_panel_view_oi_change";
      else if(plot=="all_doix")
        return "info_panel_view_ntm_oi_change";
      else if(plot=="all_vol")
        return "info_panel_view_all_vol";
      else if(plot=="all_dvolx")
        return "info_panel_view_all_dvolx";
      else return "unknown_info_panel_view";
    };
    
    const getLVOSettingsName = (plot) => {
      if(plot=="all_volx")
        return "lvo_visibility_ntm_volx";
      else return "lvo_unknown_settings";
    };
    
    const infoPanelViewName = getInfoPanelViewName(plotType);
    const lvoSettingsName = getLVOSettingsName(plotType);
    
    console.log("Updating settings:", viewName, data.panel_view_type, heightName, data.panel_height, infoPanelViewName, data.info_panel_view, lvoSettingsName, data.show_lvo);
    
    // Update userSettings temporarily (session-only, not saved to backend)
    setUserSettings((prevSettings) => {
      const newSettings = {
        ...prevSettings,
        data: {
          ...prevSettings.data,
          [viewName]: data.panel_view_type,
          [heightName]: data.panel_height,
          [infoPanelViewName]: data.info_panel_view,
          [lvoSettingsName]: data.show_lvo,
        },
      };
      console.log("New userSettings:", newSettings);
      return newSettings;
    });
    
    setVolxPanelModalVisible(false);
  }

  const changeBiToggle=(val)=>{
    if (!selectedInstrumentData) return;
    
    const instrumentKey = selectedInstrumentData.tpo_group;
    console.log("DEBUG BI Toggle: Changing SESSION toggle for", instrumentKey, "to", val);
    
    // Update session state for this specific instrument
    setFooterBiToggle(prev => ({
      ...prev,
      [instrumentKey]: val
    }));
    
    // Session-only toggle - do NOT save to global settings
    // This toggle only affects the current session and will reset on page reload
    console.log("DEBUG BI Toggle: Session toggle changed for", instrumentKey, "to", val, "- NOT saving to global settings");
  }

  const changeVolxLinesToggle=(val)=>{
    // Pass the toggle state up to the parent component
    if(props.changeVolxLinesToggle){
      props.changeVolxLinesToggle(val);
    }
  }

  const saveState = (data) => {
    console.log("Savestate called CC container====>")
    if (props.saveChartState)
      props.saveChartState(data);
    setInitialData(undefined);
    setTabData(undefined);
  } 
  return (
    <>
      {chartType == CHART_TYPE.MARKET_PROFILE ? (
      
        <ChartContainer
        id={props.id}
        val={props.val}
        boundClass={props.boundClass}
        chartScreenType={props.chartScreenType}
        setChartType={props.setChartType}
        chartStateData={props.chartStateData}
        symbol={selectedInstrument}
        resetRightPanel={props.resetRightPanel}
        setRightPanel={props.setRightPanel}
        openSubscribeModal={props.openSubscribePropModal}
        basicUser={props.basicUser}
        proUser={props.proUser}
        setChartLoaded={props.setChartLoaded}
        saveChartState={props.saveChartState}
        tabData={tabData}
        isGlobalBookmark={props.isGlobalBookmark}
        globalBookmarkData={props.globalBookmarkData}
        setIsDirty={props.setIsDirty}
        toggleRefresh={toggleRefresh}
      ></ChartContainer>
        )
       : (
        <>
          {chartType == CHART_TYPE.OF_CHART ? (
            <OrderflowContainer
              id={props.id}
              val={props.val}
              boundClass={props.boundClass}
              chartScreenType={props.chartScreenType}
              setChartType={props.setChartType}
              chartStateData={props.chartStateData}
              symbol={selectedInstrument}
              resetRightPanel={props.resetRightPanel}
              setRightPanel={props.setRightPanel}
              openSubscribeModal={props.openSubscribePropModal}
              basicUser={props.basicUser}
              proUser={props.proUser}
              setChartLoaded={props.setChartLoaded}
              saveChartState={props.saveChartState}
              tabData={tabData}
              isGlobalBookmark={props.isGlobalBookmark}
              globalBookmarkData={props.globalBookmarkData}
              setIsDirty={props.setIsDirty}
              toggleRefresh={toggleRefresh}
            ></OrderflowContainer>
          ) : (
            <></>
          )}
          {/* selectedInstudata, instrudata */}
          {console.log("Instrumentdropdown -1=",selectedInstrument,isLoading)}  
          {chartType == CHART_TYPE.LINE_CHART && instrumentsLoaded? (
            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                minHeight: 0,
              }}
            >
              <div style={{ flex: 1, minHeight: 0, overflow: "auto" }}>
                <LineChartNew
                  id={props.id}
                  val={props.val}
                  stateData={stateData}
                  symbol={selectedInstrument}
                  nDays={userSettings.data.default_lc_ndays}
                  selectedInstrumentData={selectedInstrumentData}
                  selectedInstrument={selectedInstrument}
                  instrumentsData={instrumentsData}
                  instrumentChanged={changeInstrument}
                  chartStateData={props.chartStateData}
                  boundClass={props.boundClass}
                  userSettings={userSettings}
                  changePlotType={changePlotType}
                  timeFrame={selectedTimeFrame}
                  timeFrameFooter={selectedTimeFrameFooter}
                  changeTimeFrame={changeTimeFrame}
                  selectedCot={selectedCot}
                  panel1Visible={panel1Visible}
                  changePanel1Visibility={changePanel1Visibility}
                  biToggleEnabled={biToggleEnabled}
                  volxLinesToggleEnabled={props.volxLinesToggleEnabled}
                  setChartScreenType={props.setChartScreenType}
                  initialData={initialData}
                  toggleState={toggleState}
                  // saveChartState={props.saveChartState}
                  saveChartState={(data)=>saveState(data)}
                  isGlobalBookmark={props.isGlobalBookmark}
                  globalBookmarkData={props.globalBookmarkData}
                  setIsDirty={props.setIsDirty}
                  toggleRefresh={toggleRefresh}
                  onRefreshInstruments={onRefreshInstruments}
                ></LineChartNew>
              </div>
              {selectedInstrumentData ? (
                <LineChartFooterNew
                  embedded
                  chartType={chartType}
                  chartStateData={props.chartStateData}
                  userSettings={userSettings}
                  selectedInstrumentData={selectedInstrumentData}
                  openStockChart={openStockChart}
                  selectedInstrument={selectedInstrument}
                  openLineChart={openLineChart}
                  basicUser={props.basicUser}
                  handleVPType={handleVPType}
                  handleFooterLoaded={handleFooterLoaded}
                  handleChartChange={handleChartChange}
                  auth={auth}
                  showPriceTable={showPriceTable}
                  showTable={showTable}
                  openSubscribeModal={showSubscribeModal}
                  openOFChart={openOFChart}
                  openMPChart={openMPChart}
                  openSettings={openSettings}
                  timeFrame={selectedTimeFrameFooter}
                  changeTimeFrame={changeTimeFrame}
                  plot={plotType}
                  plotData={plotData}
                  isEliteUser={isEliteUser}
                  showTimeFrame={true}
                  selectedCot={selectedCot}
                  cotChanged={cotChanged}
                  panel1Visible={panel1Visible}
                  changePanel1Visibility={changePanel1Visibility}
                  biToggleEnabled={biToggleEnabled}
                  changeBiToggle={changeBiToggle}
                  volxLinesToggleEnabled={props.volxLinesToggleEnabled}
                  changeVolxLinesToggle={changeVolxLinesToggle}
                />
              ) : null}
            </div>
          ) : (
            <></>
          )}
          {chartType == CHART_TYPE.HV_CHART ? (
            <StockChartHV
              id={props.id}
              stateData={stateData}
              symbol={selectedInstrument}
              nDays={userSettings.data.default_lc_ndays}
            ></StockChartHV>
          ) : (
            <></>
          )}
          {chartType == CHART_TYPE.BAR_CHART ? (
            // <BarChart
            //   id={props.id}
            //   stateData={stateData}
            //   symbol={selectedInstrument}
            //   nDays={userSettings.data.default_lc_ndays}
            // ></BarChart>
            <BarChartContainer
            key={0}
            val={props.val}
            id={props.id}
            symbol={selectedInstrument}
            nDays={userSettings.data.default_lc_ndays}
            boundClass={props.boundClass}
            setChartType={props.setChartType}
            resetRightPanel={props.resetRightPanel}
            setRightPanel={props.setRightPanel}
            chartScreenType={props.chartScreenType}
            basicUser={props.basicUser}
            openSubscribeModal={props.openSubscribeModal}
            proUser={props.proUser}
            chartStateData={props.chartStateData}
            stateData={stateData}
            setChartLoaded={props.setChartLoaded}
            saveChartState={props.saveChartState}
            tabData={tabData}
            setIsDirty={props.setIsDirty}
            isGlobalBookmark={props.isGlobalBookmark}
            globalBookmarkData={props.globalBookmarkData}
            toggleRefresh={toggleRefresh}
            revertToPreviousChart={revertToPreviousChart}
          />
          ) : (
            <></>
          )}

          {chartType != CHART_TYPE.OF_CHART && chartType != CHART_TYPE.MARKET_PROFILE && chartType != CHART_TYPE.BAR_CHART && chartType != CHART_TYPE.LINE_CHART &&  selectedInstrumentData ? (
            <LineChartFooterNew
              chartType={chartType}
              chartStateData={props.chartStateData}
              userSettings={userSettings}
              selectedInstrumentData={selectedInstrumentData}
              openStockChart={openStockChart}
              selectedInstrument={selectedInstrument}
              openLineChart={openLineChart}
              basicUser={props.basicUser}
              handleVPType={handleVPType}
              handleFooterLoaded={handleFooterLoaded}
              handleChartChange={handleChartChange}
              auth={auth}
              showPriceTable={showPriceTable}
              showTable={showTable}
              openSubscribeModal={showSubscribeModal}
              openOFChart={openOFChart}
              openMPChart={openMPChart}
              openSettings={openSettings}
              timeFrame={selectedTimeFrameFooter}
              changeTimeFrame={changeTimeFrame}
              plot={plotType}
              plotData={plotData}
              isEliteUser={isEliteUser}
              showTimeFrame={true}
              selectedCot={selectedCot}
              cotChanged={cotChanged}
              panel1Visible={panel1Visible}
              changePanel1Visibility={changePanel1Visibility}
              biToggleEnabled={biToggleEnabled}
              changeBiToggle={changeBiToggle}
              volxLinesToggleEnabled={props.volxLinesToggleEnabled}
              changeVolxLinesToggle={changeVolxLinesToggle}
            />
          ) : (
            <></>
          )}
        </>
      )}
      {showSettings?
      <>
      {(plotData.plot=="fut" || plotData.plot=="opt") && plotData.doix==false?
      <>
      {selectedInstrumentData.of?
       <CandleSettings plot={"candle"} open={true} proUser={props.proUser} selectedInstrumentData={selectedInstrumentData} instrument={selectedInstrument} cancelHandler={cancelSettings} saveHandler={saveSettings} />
       :<></>}
       </>
        :
        
        <LineChartSettingsNew open={true}  plotData={plotData} plot={plotType} cancelHandler={cancelSettings} saveHandler={saveSettings} />    
      }
      </>
      
     :<></>
    }
    {showDemoPopup?
      <OfDemoPopup open={true} demoIndex={demoIndex} demoType={showDemoState.demoType} hasOfferTr={showDemoState.hasOfferTr} onClose={()=>setShowDemoPopup(false)} onDemoStart={()=>setShowDemoConfirmPopup(true)}></OfDemoPopup>
      :
      <></>
    }
    {showDemoConfirmPopup?
      <DemoConfirmationPopup open={true} demoType={showDemoState.demoType} onClose={()=>setShowDemoConfirmPopup(false)}></DemoConfirmationPopup>
      :
      <></>
    }
    {/* Volx Settings Modal (Session-only control panel) */}
    {plotType === "all_volx" && volxPanelModalVisible?
      <VolxSettingsModal 
        open={volxPanelModalVisible} 
        plot={plotType}
        userSettings={userSettings}
        onClose={() => {
          setVolxPanelModalVisible(false);
          changePanel1Visibility(false, true);
        }}
        onSave={applyVolxSettings}
      />:
      <></>
    }
    <AppErrorPopup
      open={open}
      message={msg}
      severity={severity}
      onClose={handleClose}
      showCloseX
    />
    </>
  )
}

export default LineChartContainerNew